import { useEffect, useState } from 'react';
import './css/Entidade.css';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate } from 'react-router-dom';
import LoadingModal from './components/modals/LoadingModal';
import Pagination10 from './components/Pagination10';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import ConfirmModal from './components/modals/ConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ResponsiveShadow from './components/ResponsiveShadow';
import usePagination10 from './components/hooks/usePagination10';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import EntidadeModal from './components/modals/EntidadeModal';
import PaginationBar from './components/PaginationBar';
import TableContainer from './components/TableContainer';
import DataTable from './components/DataTable';
import { formatCNPJ } from './utils/cnpjUtils';

function Entidades() {
  const [Entidades, setEntidades] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [atualizar, setAtualizar] = useState([]);
  const [entidadeSelecionada, setEntidadeSelecionada] = useState(null);
  const [showEntidadeModal, setShowEntidadeModal] = useState(false);
  const [editingEntidade, setEditingEntidade] = useState(null);
  const token = localStorage.getItem('token');
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();

  useEffect(() => {
    if (!token) {
      navigate('/');
    }
    setLoading(true);
    axios
      .get(`${API_BASE_URL.ENTIDADE}/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        setEntidades(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter entidades:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [atualizar]);

  function handleDelete(c) {
    showConfirmModal('delete', () => handleConfirmDelete(c));
  }

  function handleConfirmDelete(c) {
    axios
      .get(`${API_BASE_URL.VINCULO}/exists_entidade/` + c.idEntidade, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        if (result.data.exists) {
          showDefaultModal(
            'error',
            'Esta Entidade/Entidade possui vínculos e não pode ser excluído. Exclua os vínculos antes de tentar novamente.'
          );
        } else {
          axios
            .delete(`${API_BASE_URL.ENTIDADE}/delete/` + c.idEntidade, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then(() => {
              setAtualizar(prev => !prev);
            });
        }
      })
      .catch(error => {
        console.error('Erro ao verificar vínculos:', error);
        showDefaultModal('error', 'Erro ao excluir o registro!');
        setTimeout(() => navigate('/'), 0);
      });
  }

  const normalizeString = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const entidadesFiltrados = Array.isArray(Entidades)
    ? Entidades.filter(c => {
        const normalizedBusca = normalizeString(filtro);
        return (
          normalizeString(c.nome || '').includes(normalizedBusca) ||
          normalizeString(c.cnpj || '').includes(normalizedBusca) ||
          normalizeString(c.logrCidade || '').includes(
            normalizedBusca
          ) ||
          normalizeString(c.logrUf || '').includes(normalizedBusca)
        );
      })
    : [];

  // Paginação dos entidades filtrados
  const totalItems = entidadesFiltrados.length;
  const { setPagination } = usePagination10(totalItems);
  const selectedEntidades = entidadesFiltrados.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Entidades Cadastradas" icon="bi-building" />
        <PageContent>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex gap-2">
              <button
                className="btn btn-success btn-sm"
                title="Cadastrar nova entidade"
                onClick={() => {
                  setEditingEntidade(null);
                  setShowEntidadeModal(true);
                }}
              >
                <i className="bi bi-plus-circle me-1"></i>
                Novo
              </button>
              <button
                className="btn btn-primary btn-sm"
                disabled={!entidadeSelecionada}
                onClick={() => {
                  if (entidadeSelecionada) {
                    setEditingEntidade(entidadeSelecionada);
                    setShowEntidadeModal(true);
                  }
                }}
                title="Editar entidade selecionada"
              >
                <i className="bi bi-pencil me-1"></i>
                Editar
              </button>
              <button
                className="btn btn-danger btn-sm"
                disabled={!entidadeSelecionada}
                onClick={() => handleDelete(entidadeSelecionada)}
                title="Excluir entidade selecionada"
              >
                <i className="bi bi-trash me-1"></i>
                Excluir
              </button>
            </div>
            <div className="col-md-4">
              <div className="input-group input-group-sm">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Buscar por CNPJ, Nome ou Cidade"
                  value={filtro}
                  onChange={e => setFiltro(e.target.value.toUpperCase())}
                />
              </div>
            </div>
          </div>

          <TableContainer isLoading={isLoading}>
                        <DataTable style={{ fontSize: '0.8rem' }} head={
                <tr>
                  <th scope="col" className="px-2 d-none d-md-table-cell">
                    CNPJ
                  </th>
                  <th scope="col" className="px-2">
                    Nome
                  </th>
                  <th scope="col" className="px-2">
                    Cidade
                  </th>
                  <th scope="col" className="px-2">
                    UF
                  </th>
                </tr>}>
              <tbody>
                {!isLoading &&
                  selectedEntidades.map(c => (
                    <tr
                      key={c.idEntidade}
                      className={
                        entidadeSelecionada &&
                        entidadeSelecionada.idEntidade === c.idEntidade
                          ? 'table-primary'
                          : ''
                      }
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (
                          entidadeSelecionada &&
                          entidadeSelecionada.idEntidade === c.idEntidade
                        ) {
                          setEntidadeSelecionada(null); // Desseleciona se já estiver selecionada
                        } else {
                          setEntidadeSelecionada(c); // Seleciona a entidade
                        }
                      }}
                    >
                      <td className="px-2 d-none d-md-table-cell">{formatCNPJ(c.cnpj)}</td>
                      <td className="px-2">{c.nome}</td>
                      <td className="px-2">
                        {c.logrCidade || '-'}
                      </td>
                      <td className="px-2">{c.logrUf || '-'}</td>
                    </tr>
                  ))}
              </tbody>
            </DataTable>
          </TableContainer>
          <ConfirmModal {...setConfirmModal} />
          <DefaultModal {...setDefaultModal} />
          <EntidadeModal
            show={showEntidadeModal}
            onClose={() => {
              setShowEntidadeModal(false);
              setEditingEntidade(null);
            }}
            onSuccess={() => {
              setShowEntidadeModal(false);
              setEditingEntidade(null);
              setAtualizar(prev => !prev);
            }}
            entidade={editingEntidade}
          />
        </PageContent>
        <PaginationBar setPagination={setPagination}/>
      </ResponsiveShadow>
    </Layout>
  );
}

export default Entidades;
